export default {"src":"/_next/static/media/feature-image-02.8dac2533.svg","height":560,"width":622,"blurWidth":0,"blurHeight":0};